import React from 'react'
import { Link } from 'react-router-dom';
import { ReactComponent as LikeIcon} from '../../../images/public/header/heart.svg'
import { useState } from 'react';
import ApiUrl from '../../../configTools/apiUrl';

const CommentItem = ({Comment, RefreshComment, setReplyto}) => {
    const [User,setUser] = useState(JSON.parse(localStorage.getItem("user-info")));
    
    const change_like = ()=>{
        fetch(ApiUrl.API_URL_CommentsLike, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify({
                commentid : Comment.id
            })
          })
          .then(res=>res.json())
          .then(data =>{
            RefreshComment();
        });
    }
    const delete_comment = ()=>{
        fetch(ApiUrl.API_URL_CommentDelete, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body:JSON.stringify({
                id:Comment.id
            })
          })
          .then(res=>res.json())
          .then(data =>{
            RefreshComment();
        });
    }
  return (
    <div className='comments_list_item'>
        <div className='comments_list_item_image'>
            <div className='comments_list_item_image_container' style={{
            backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+Comment.image})`
            }}>
            </div>
        </div>
        <div className='comments_list_item_details'>
            <Link to={"/user/"+Comment.username}><h3>{Comment.firstname} {Comment.lastname}</h3></Link>
            <p>{
            Comment.replytoUsername !== "" &&
            <Link to={'/user/'+Comment.replytoUsername}><span>@{Comment.replytoUsername}</span></Link>
            }{Comment.discription}</p>
            <div className='comments_list_item_details_buttons'>
                <div className='comments_list_item_details_buttons_item'>
                    <LikeIcon width="10px" height="20px" onClick={change_like} />
                </div>
                <div className='comments_list_item_details_buttons_item'>
                    <p>{Comment.likes}</p>
                </div>
                {User &&
                    <>
                        {User.id !== Comment.userid &&
                            <div className='comments_list_item_details_buttons_item' onClick={()=>{
                                setReplyto({
                                    id: Comment.userid,
                                    username: Comment.username
                                })
                            }}>
                                <p>Reply</p>
                            </div>
                        }
                        {User.id === Comment.userid &&
                            <div className='comments_list_item_details_buttons_item' onClick={delete_comment}>
                                <p>Delete</p>
                            </div>
                        }
                    </>
                }
            </div>
        </div>
    </div>
  )
}

export default CommentItem
